import SideNavigation, { SideNavigationProps } from '@amzn/awsui-components-react/polaris/side-navigation';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Paths from '../paths/paths';
import { usePermissions } from '../permissions/PermissionsContext';
import { CATALOG_MANAGEMENT_URL } from 'configuration/config';

const OrderDashboardURL = "https://metrics-it.corp.amazon.com/#/site/Global-IT/views/ITMPOrderStatus/ITMPsoftwareorderstatus";

const header = { text: 'IT SAM admin', href: Paths.Admin.url };

function buildNavItems(hasGspTracker: boolean): SideNavigationProps.Item[] {
    const items: SideNavigationProps.Item[] = [
        {
            type: 'section',
            text: 'Orders',
            items: [
                { type: 'link', text: Paths.manageOrders.name, href: Paths.manageOrders.url },
                { type: 'link', text: Paths.uploadOrders.name, href: Paths.uploadOrders.url },
                { type: 'link', text: Paths.ordersDownloaded.name, href: Paths.ordersDownloaded.url },
                { type: 'link', text: 'View order dashboard', href: OrderDashboardURL, external: true },
            ]
        },
    ];

    if (hasGspTracker) {
        items.push({
            type: 'section',
            text: 'Procurement',
            items: [
                { type: 'link', text: Paths.bulkOrders.name, href: Paths.bulkOrders.url },
                { type: 'link', text: Paths.bulkOrdersTemplates.name, href: Paths.bulkOrdersTemplates.url },
                { type: 'link', text: Paths.productInventory.name, href: Paths.productInventory.url },
                { type: 'link', text: Paths.poConfiguration.name, href: Paths.poConfiguration.url },
                { type: 'link', text: Paths.resellerReportHistory.name, href: Paths.resellerReportHistory.url },
            ]
        });
    }

    items.push(
        {
            type: 'section',
            text: 'Licenses',
            items: [
                { type: 'link', text: Paths.manageLicense.name, href: Paths.manageLicense.url },
                { type: 'link', text: Paths.uploadLicense.name, href: Paths.uploadLicense.url },
            ]
        },
        {
            type: 'section',
            text: 'Catalog',
            defaultExpanded: false,
            items: [
                { type: 'link', text: 'Manage catalog', href: CATALOG_MANAGEMENT_URL, external: true },
                { type: 'link', text: Paths.contentBackfill.name, href: Paths.contentBackfill.url },
            ]
        },
        { type: "divider" },
    );

    return items;
}

const SideNavigationMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { hasGspTracker } = usePermissions();

    const items = useMemo(() => buildNavItems(hasGspTracker), [hasGspTracker]);

    /**
     * Prevents reloading the page and lets react router handle the redirect
     * @param event
     */
    const onFollowHandler = (event: CustomEvent<SideNavigationProps.FollowDetail>) => {
        if (!event.detail.external){
            event.preventDefault();
            if (event.detail.href) {
                navigate(event.detail.href);
            }
        }
    };

    return (
        <SideNavigation
            data-testid={"side-nav"}
            header={header}
            items={items}
            activeHref={location.pathname}
            onFollow={onFollowHandler}
        />
    );
}

export default SideNavigationMenu;
